
var QuizManager = function( minDigit, maxDigit, stageCount, completeCount ){

    this.allData = [];
    this.stagedDigit = [];
    this.correctIndex = null;
    this.__firstDigit = null;

    this.minDigit = minDigit;
    this.maxDigit = maxDigit;
    this.stageCount = stageCount;

    this.completeCount = completeCount

    this.correctCount = 0;
    this.__firstAnswer = true;

    this.skipCount = 0;
    this.missCount = 0;
}

QuizManager.prototype = {

    init: function(){
        this.setAllData();
        this.shuffleData();
        this.__firstDigit = this.allData[0]
        this.setStage();
        this.correctCount = 0;
        this.__firstAnswer = true;
        this.skipCount = 0;
        this.missCount = 0;
    },

    setAllData: function(){

        this.allData = [];
        for( var i = this.minDigit ; i <= this.maxDigit ; i++ ){
            this.allData.push( i );
        }
    },

    shuffleData: function(){
        for(var i = this.allData.length - 1; i > 0; i--){
            var r = Math.floor(Math.random() * (i + 1));
            var tmp = this.allData[i];
            this.allData[i] = this.allData[r];
            this.allData[r] = tmp;
        }
        this.__firstDigit = this.allData[0]
    },

    setStage: function(){
        this.stagedDigit = this.allData.splice(0, this.stageCount);
        this.setCorrectIndex();
    },

    judge: function( idx ){
        if( idx == this.correctIndex ){
            if( this.__firstAnswer == true ){
                this.correctCount++;
            }else{
                this.missCount++;
            }
            this.next();
            return true;
        }

        this.__firstAnswer = false;
        return false;
    },

    next: function(){
        if( this.isCompleted() == true ){
            return;
        }

        var usedDigit = this.getCurrentDigit()
        this.allData.push( usedDigit )

        if( this.allData[0] == this.__firstDigit ){
            this.shuffleData()
        }

        var newDigit = this.allData.splice(0, 1)[0];

        this.__firstAnswer = true;
        this.stagedDigit.splice( this.correctIndex, 1, newDigit );
        this.setCorrectIndex();
    },

    setCorrectIndex: function(){
        this.correctIndex = Math.floor( Math.random() * ( this.stageCount ) );
    },

    getCurrentDigit: function(){
        return this.stagedDigit[ this.correctIndex ];
    },

    reset: function(){
        this.init();
    },

    getCorrectCount: function(){
        return this.correctCount;
    },

    getMissCount: function(){
        return this.missCount;
    },

    skip: function(){
        this.skipCount++;
        this.next();
    },

    getSkipCount: function(){
        return this.skipCount;
    },

    isCompleted: function(){
        if( ( this.correctCount + this.missCount ) >= this.completeCount ){
            return true;
        }
        return false;
    },

    getProgressScore: function(){
        return this.getProgressCount() + ' / ' + this.completeCount;
    },

    getProgressCount: function(){
        return this.correctCount + this.missCount
    },

    progressPercent: function(){
        return ( this.getProgressCount() / this.completeCount ) * 100
    },

    skipPercent: function(){
        if( this.skipCount > this.completeCount ){
            return 100;
        }
        return ( this.skipCount / this.completeCount ) * 100
    },

    missPercent: function(){
        if( this.missCount > this.completeCount ){
            return 100;
        }
        return ( this.missCount / this.completeCount ) * 100
    }

}

export{ QuizManager }
